import { decompressFromEncodedURIComponent } from 'lz-string';
const flemsCode = document.URL.split('#0=')[1];
let code = JSON.parse(decompressFromEncodedURIComponent(flemsCode) || "{}");
if (code && code.name) document.title = `${code.name} - Flems Preview`
Flems(document.body, code);